import type { App } from 'vue';
import { RecycleScroller } from 'vue-virtual-scroller';

// Upstream `RecycleScroller` is authored with `<script setup>`, so its compiled
// render function is not exposed via Options API `extends`. Subclassing with
// `defineComponent({ extends: RecycleScroller, ... })` therefore produced a
// component with no render function and dynamic `:is="'activix-recycle-scroller'"`
// rendered an empty element. Alias the upstream component under the legacy name
// so slots keep working. Upstream `getScroll` already handles the viewport-size
// clamp the old override provided; the only behavior we drop is allowing a
// negative `start` in page-mode (upstream clamps to 0).
const ActivixRecycleScroller = RecycleScroller;

export const virtualScrollerPlugin = {
    install(app: App) {
        app.component('RecycleScroller', RecycleScroller);
        app.component('ActivixRecycleScroller', ActivixRecycleScroller);
    },
};

export default virtualScrollerPlugin;
